export const STAGE_LABELS = {
  ASSIGNMENT: "Assignment",
  ADMIN: "Admin",
  HOD: "HOD",
  FINANCE: "Finance",
  CLIENT_PAYMENT: "Client payment",
  SYSTEM: "System",
};

export const ACTION_LABELS = {
  CREATED: "Created",
  SUBMITTED_TO_HOD: "Submitted to HOD",
  RESUBMITTED: "Resubmitted",
  WITHDRAWN: "Withdrawn from HOD",
  DELETED: "Deleted",
  ADMIN_APPROVAL_REQUESTED: "Admin approval requested",
  ADMIN_APPROVED: "Admin approved",
  ADMIN_REJECTED: "Admin rejected",
  HOD_APPROVED: "HOD approved",
  HOD_REJECTED: "HOD rejected",
  HOD_REVIEW_CLEARED: "HOD review cleared",
  FINANCE_STATUS_CHANGED: "Finance status changed",
  PAYMENT_APPROVED_PAID: "Payment approved (paid)",
  FINANCE_REJECTED: "Finance rejected",
  PAYMENT_DETAILS_UPDATED: "Payment details updated",
  INTERNAL_DUE_DATE_UPDATED: "Internal due date updated",
  CLIENT_PAID_STATUS_CHANGED: "Client paid status changed",
  DUE_REMINDER_SENT: "Due reminder sent",
};

export const ACTION_ICONS = {
  CREATED: "fa-plus-circle",
  SUBMITTED_TO_HOD: "fa-paper-plane",
  RESUBMITTED: "fa-refresh",
  WITHDRAWN: "fa-undo",
  DELETED: "fa-trash",
  ADMIN_APPROVAL_REQUESTED: "fa-hourglass-half",
  ADMIN_APPROVED: "fa-check-circle",
  ADMIN_REJECTED: "fa-times-circle",
  HOD_APPROVED: "fa-check-circle",
  HOD_REJECTED: "fa-times-circle",
  HOD_REVIEW_CLEARED: "fa-eraser",
  FINANCE_STATUS_CHANGED: "fa-exchange",
  PAYMENT_APPROVED_PAID: "fa-money",
  FINANCE_REJECTED: "fa-times-circle",
  PAYMENT_DETAILS_UPDATED: "fa-pencil",
  INTERNAL_DUE_DATE_UPDATED: "fa-calendar",
  CLIENT_PAID_STATUS_CHANGED: "fa-exchange",
  DUE_REMINDER_SENT: "fa-bell",
};

const STATUS_LABELS = {
  in_progress: "To Be Processed",
  proceeded: "Processed",
  paid: "Paid",
  unpaid: "Unpaid",
  overdue: "Overdue",
  rejected: "Rejected",
  approved: "Approved",
  pending: "Pending",
  not_required: "Not required",
  yes: "Yes",
  no: "No",
};

export function statusLabel(v) {
  if (v == null || v === "") return "—";
  return STATUS_LABELS[v] || String(v);
}

/** Green for approved/paid, red for rejected, amber for pending/requested, grey otherwise. */
export function actionBadgeClass(action, toStatus) {
  const a = String(action || "");
  const to = String(toStatus || "");
  if (a === "PAYMENT_APPROVED_PAID" || a.endsWith("_APPROVED") || to === "paid") {
    return "bg-success";
  }
  if (a.endsWith("_REJECTED") || to === "rejected") return "bg-danger";
  if (a.endsWith("_REQUESTED") || a === "SUBMITTED_TO_HOD" || a === "RESUBMITTED" || to === "pending") {
    return "bg-warning text-dark";
  }
  return "bg-secondary";
}

export function formatDateTime(d) {
  if (!d) return "—";
  const date = new Date(d);
  if (Number.isNaN(date.getTime())) return "—";
  const day = date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  const time = date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false });
  return `${day}, ${time}`;
}

export function formatDate(d) {
  if (!d) return "—";
  const date = new Date(d);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

const DATE_FIELDS = new Set(["paymentDate", "dueDate", "internalDueDate"]);

/** Human-readable value for the "changes" diff table. */
export function formatChangeValue(field, v) {
  if (v == null || v === "") return "—";
  if (Array.isArray(v)) {
    if (!v.length) return "—";
    return v.map((x) => (x && typeof x === "object" ? x.originalName || x.path : String(x))).join(", ");
  }
  if (DATE_FIELDS.has(field)) return formatDate(v);
  if (typeof v === "object") return JSON.stringify(v);
  return statusLabel(v);
}

export function soLabel(bo) {
  if (!bo || typeof bo !== "object") return "—";
  return bo.boNo || bo.invoiceNumber || "—";
}

export function actorLabel(log) {
  if (!log) return "—";
  const name = log.actorName || (log.actorId ? "Unknown user" : "System");
  return log.actorRole ? `${name} (${log.actorRole})` : name;
}
